var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-seach-wrap"},[(_vm.activeName=='reserve')?_c('Reserve'):_vm._e(),_vm._v(" "),(_vm.activeName=='store')?_c('Store'):_vm._e(),_vm._v(" "),(_vm.activeName=='clerk')?_c('Clerk'):_vm._e(),_vm._v(" "),(_vm.activeName=='sku')?_c('Sku'):_vm._e(),_vm._v(" "),(_vm.activeName=='setting')?_c('Setting'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f900555","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/reserve/index.vue
// module id = null
// module chunks = 